import setParamsByUser from 'utils/analytics/setParamsByUser';
import { getSessionType, userBasicGuard } from 'utils/clickme';
import { Permissions } from 'utils/constants/permissions';

import { Requirements } from 'app/routes';

import { ClickmeConfig, setClickmeConfig } from 'store/models/clickme';
import { setLoadUser, setSessionType, setUser, setUserPermissions, UserInfoDto, UserType } from 'store/models/user';

const ModeratorRequirements: Requirements<{
    user: UserInfoDto;
    config: ClickmeConfig;
}> = {
    methods: () => ({ user: { url: '/api/v1/user' }, config: { url: '/api/v1/config' } }),
    resolve: ({ result: { user, config }, state }) => {
        const { actualUser } = user;
        const permissions = [];

        if (user.user.userType === UserType.Moderator) {
            permissions.push(Permissions.ViewModeration);
        } else if (user.user.userType === UserType.SuperAdmin) {
            permissions.push(
                Permissions.ViewAdminSection,
                Permissions.ViewAdminFullMenu,
                Permissions.ViewAdminReports,
                Permissions.ViewAdminBonusForm,
                Permissions.ViewAdminInvoiceDetailPage,
                Permissions.ViewModeration
            );
        }
        setParamsByUser(user.user, state.user.loginData);
        return [
            setUserPermissions(permissions),
            setLoadUser(false),
            setUser(user.user),
            setSessionType(getSessionType(actualUser)),
            setClickmeConfig(config),
        ];
    },
    error: (err) => [setUserPermissions(userBasicGuard(err)), setLoadUser(false)],
};

export { ModeratorRequirements };
